import React from "react";
import {Control, Errors, Form} from "react-redux-form";
import {register} from "../../../../actions/auth-actions";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { actions } from "react-redux-form";
import {Card, CardBody, Collapse} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class RegistrationForm extends React.Component {

    formModel = 'forms.usersRegistration';

    constructor(params) {
        super(params);
        this.state = {
            souhlas: false
        };

        this.check = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            let { from } = this.props.location.state || { from: { pathname: '/' } };
            nextProps.push(from);
        }
    }

    register = (values) => {
        this.props.resetValidity(this.formModel);
        this.props.submitFields(this.formModel, this.props.onSubmit(values));
    };

    render() {
        return (
            <Form model={this.formModel} onSubmit={this.register}>
                <Errors model="forms.users.registration" />
                <div className='form-group'>
                    <label>Jméno</label>
                    <Control.text model='.name' className='form-control'/>
                    <Errors model=".name" className='text-danger form-text small'/>
                </div>
                <div className='form-group'>
                    <label>Email</label>
                    <Control.text model='.email' className='form-control'/>
                    <Errors model=".email" className='text-danger form-text small'/>
                </div>
                <div className='form-group'>
                    <label>Heslo</label>
                    <Control.password model='.password' className='form-control' onChange={() => { this.props.setValidity(this.formModel + '.password', true) }}/>
                    <Errors model=".password" className='text-danger form-text small'/>
                </div>
                <div className='form-group'>
                    <label>Heslo ješte jednou</label>
                    <Control.password model='.password_confirmation' className='form-control'/>
                    <Errors model=".password_confirmation" className='text-danger form-text small'/>
                </div>
                <div className='separate'>
                <div className='form-group'>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="souhlas" ref="check" onChange={() => { this.setState({}) }}/>
                        <label className="form-check-label" htmlFor="souhlas">Souhlasím se zpracování osobních údajů a GDPR</label> <FontAwesomeIcon icon={['far','question-circle']}/>
                    </div>
                </div>
                    <Collapse isOpen={this.state.souhlas}>
                        Odesláním formuláře souhlasíte, aby společnost yourchance o.p.s., se sídlem Argentinská 38, 170 00 Praha 7, IČ: 24717975, ve smyslu nařízení Evropského parlamentu Rady č. 2016/679 ze dne 27. 4. 2016 o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (dále jen „Nařízení GDPR“) zpracovala vaše uvedené osobní údaje.
                    </Collapse>
                </div>
                <div className='separate'>
                    <button className='btn btn-primary btn-block' disabled={this.props.auth.userRegistration || !this.refs.check || !this.refs.check.checked}>Registrovat se</button>
                </div>
            </Form>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        register: register,
        submitFields: actions.submitFields,
        resetValidity: actions.resetValidity,
        setValidity: actions.setValidity
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(RegistrationForm);
